<script>
	import Helper from '../../Models/Helper';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';
	import Trigger from '../../Models/Trigger';
	import {beforeUpdate, afterUpdate} from 'svelte';
	import {onMount} from 'svelte';

	let shrink = false;
	let slide = false;
	let bar = {};
	let slider = {};
	let old_instant;
	let instant = false;
	let app_width = 0;
	let box_width = 0;
	let bar_center = 0;

	function reset() {
		jQuery(slider).find('> div.box').each((index, item) => {
			jQuery(item).data('init-boxes', false);
			jQuery(item).css('width', '');
		});
	}

	function init() {
		app_width = jQuery('#app').outerWidth();
		box_width = Math.round(app_width);

		const bar_width = jQuery(bar).width();
		bar_center = Math.round(bar_width / 2);
	}

	function onSwipe(event) {
		const directions = event.detail.directions;
		/* Vertical gestures are the reader scrolling; they were never navigation. */
		if (!directions.left && !directions.right) return;

		/*
		 * A slide can hold navigation — chapter audio does, so a stray gesture
		 * cannot jump chapters mid-sentence. Say why and stop here, before
		 * Slider.route pushes a history entry.
		 */
		const notice = Slider.holding();
		if (notice) return Trigger.event('alert', notice);

		if (directions.left) Slider.route('next', 'previous');
		else Slider.route('previous', 'next');
	}

	function boxes() {
		jQuery(slider).find('> div.box').each((index, item) => {
			if (!jQuery(item).data('init-boxes')) {
				jQuery(item).data('init-boxes', true);
				jQuery(item).css('width', box_width);

				if (Helper.touch() && !jQuery(item).data('init-swipe')) {
					const swiper = SwipeListener(item);
					item.addEventListener('swipe', onSwipe);
					jQuery(item).data('init-swipe', true);
				}
			}
		});
	}

	function box(element) {
		return element.is('div.box') ? element : element.parents('div.box').first();
	}

	function property(name) {
		var style = window.getComputedStyle(document.body);
		return style.getPropertyValue(`--${name}`);
	}

	function to(element) {
		const item = box(element);
		const menu_active = $Session.menu.active;
		if (!menu_active &&  box && box.length && item.length)
		{
			const width = item.outerWidth(true);
			const left = item.position().left;
			const position = Math.round(bar_center - left - (width / 2));

			item.parent().css('transform', `translateX(${position}px)`);
			old_instant = instant;
		}
	}

	function sliderChange(slides) {
		instant = $Slider.active.instant;
		slide = true;
	}

	function menuChange(state) {
		shrink = state.active;
		jQuery(bar).off('click');
		if (state.active && !state.block_bar)
			jQuery(bar).on('click', () => Session.toggleMenu());
	}

	function onAfterUpdate(force) {
		if (slide || force) {
			slide = false;
			boxes();
			const target = jQuery('#slider div.box.active');
			if (target.length) to(target);
		}
	}

	window.addEventListener('orientationchange', event => {
		const resized = () => {
			reset();
			init();
			onAfterUpdate(true);
			window.removeEventListener('resize', resized);
		};

		window.addEventListener('resize', resized);
	});

	afterUpdate(() => onAfterUpdate());
	onMount(() => {
		init();
		Slider.subscribe(slides => sliderChange(slides));
		Session.subscribe(state => {
			menuChange(state.menu);
		});
	});

</script>

<style>
	#bar {
		position: absolute;
		overflow: hidden;
		top: 7.7em;
		bottom: 0;
		width: 100%;
		margin: 0 auto;
		transform-origin: right;
		transition: transform .25s ease-out, opacity .5s ease-in;
		will-change: transform;
	}

	#bar.shrink {
		transform: translateX(30vw);
	}

	#slider {
		position: absolute;
		overflow: hidden;
		top: 0;
		bottom: 0;
		transform: translateX(0);
		display: flex;
		transition: transform .2s ease-out;
		width: calc(100vw * 7);
		will-change: transform;
	}

	#bar.instant #slider {
		transition: none;
	}

	@media (max-device-width: 1024px) {
		#bar {
			top: 5.2em;
		}

		#bar.shrink {
			transform: translateX(60vw);
		}
	}

	@media (min-device-width: 768px) and (max-device-width: 1024px) {
		#bar.shrink {
			transform: translateX(37vw);
		}
	}
</style>

<div id="bar" bind:this="{bar}" class:shrink class:instant>
	<div id="slider" bind:this="{slider}">
		<svelte:component this="{$Slider.slide_1.component}" index="1"/>
		<svelte:component this="{$Slider.slide_2.component}" index="2"/>
		<svelte:component this="{$Slider.slide_3.component}" index="3"/>
		<svelte:component this="{$Slider.slide_4.component}" index="4"/>
		<svelte:component this="{$Slider.slide_5.component}" index="5"/>
		<svelte:component this="{$Slider.slide_6.component}" index="6"/>
		<svelte:component this="{$Slider.slide_7.component}" index="7"/>
	</div>
</div>